export const DROPSHIPMENT_KEYS = {
  all: ['dropshipment'] as const,
  products: (cohortid: string | number) => [...DROPSHIPMENT_KEYS.all, 'products', String(cohortid)] as const,
  addressFind: (query: string) => [...DROPSHIPMENT_KEYS.all, 'address-find', query] as const,
  orders: (userid: string | number) => [...DROPSHIPMENT_KEYS.all, 'orders', String(userid)] as const,
} as const;
